import { z } from "zod";

const formFieldsSchema = z.object({
	name: z.string().trim().min(1).max(100),
	email: z.string().trim().email().max(254),
	type: z.enum(["person", "company"]),
	description: z.string().trim().max(1000).default(""),
	earlyAccessEmail: z.boolean().refine((v) => v === true, { message: "required" }),
	updates: z.boolean().default(false),
});

export const earlyAccessSchema = formFieldsSchema.extend({
	turnstileToken: z.string().min(1).max(2048),
});

export type EarlyAccessPayload = z.infer<typeof earlyAccessSchema>;

export function validateFormFields(data: Record<string, unknown>): boolean {
	return formFieldsSchema.safeParse(data).success;
}

const ZOD_I18N: Record<string, Record<string, string>> = {
	name: {
		too_small: "errorNameRequired",
		too_big: "errorNameMax",
	},
	email: {
		too_small: "errorEmailRequired",
		invalid_type: "errorEmailRequired",
		invalid_string: "errorEmailInvalid",
		too_big: "errorEmailMax",
	},
	type: {
		invalid_value: "errorTypeInvalid",
	},
	description: {
		too_big: "errorDescMax",
	},
	earlyAccessEmail: {
		invalid_value: "errorEarlyAccessEmail",
		custom: "errorEarlyAccessEmail",
	},
	turnstileToken: {
		too_small: "errorCaptchaToken",
		too_big: "errorCaptchaToken",
	},
};

export function zodErrorToI18n(
	issues: z.ZodIssue[],
	t: (key: string) => string,
): Record<string, string> {
	const errors: Record<string, string> = {};
	for (const issue of issues) {
		const path = String(issue.path[0] ?? "");
		const code = issue.code;

		if (code === "custom" && !path && issue.message === "required") {
			if (!errors.earlyAccessEmail) errors.earlyAccessEmail = t("errorEarlyAccessEmail");
			continue;
		}

		const key = ZOD_I18N[path]?.[code];
		if (key && !errors[path]) {
			errors[path] = t(key);
		}
	}
	return errors;
}
